import { faFacebook, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import {
  faArrowRight,
  faEnvelope,
  faComments,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import contactsHero from "../Assets/heroes/contacts-hero.webp";
import PrimaryHero from "../Components/PrimaryHero";
import SectionHeading from "../Components/SectionHeading";

const contactMethods = [
  {
    icon: faEnvelope,
    title: "Email us",
    label: "info@milesoft.africa",
    href: "mailto:info@milesoft.africa",
    copy: "Best for project details, support requests, and product ideas.",
  },
  {
    icon: faFacebook,
    title: "Message on Facebook",
    label: "@MileSoft.Africa",
    href: "https://fb.me/MileSoft.Africa",
    copy: "Useful for quick questions, updates, and direct messages.",
  },
  {
    icon: faXTwitter,
    title: "Follow on X",
    label: "@MileSoftAfrica",
    href: "https://x.com/MileSoftAfrica",
    copy: "Follow MileSoftAfrica for lightweight updates and conversation.",
  },
];

function Contacts() {
  return (
    <div className="primary-page">
      <PrimaryHero
        titleId="contact-title"
        icon={faComments}
        kicker="Contact"
        title="Let's build something simple that works."
        description={
          <p>
            Tell MileSoft what you want to improve, build, or make easier. We
            will help turn the idea into a practical next step.
          </p>
        }
        imageSrc={contactsHero}
        actions={
          <a
            href="mailto:info@milesoft.africa"
            className="btn-ms btn-ms-primary btn-ms-lg"
          >
            Email MileSoft
            <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
          </a>
        }
      />

      <section
        className="section-ms section-ms-soft"
        aria-labelledby="contact-methods-title"
      >
        <div className="section-ms-inner">
          <SectionHeading
            titleId="contact-methods-title"
            kicker="Contact options"
            title="Choose the easiest way to reach us"
            description={
              <p>
                Email is best for project details. Social channels are better
                for quick questions and updates.
              </p>
            }
          />
          <div className="contact-grid">
            {contactMethods.map((method) => {
              const isMail = method.href.startsWith("mailto:");

              return (
                <article className="contact-method" key={method.title}>
                  <div>
                    <div className="primary-card-meta">
                      <span className="brand-icon" aria-hidden="true">
                        <FontAwesomeIcon icon={method.icon} />
                      </span>
                      <span className="badge-ms">{method.title}</span>
                    </div>
                    <p>{method.copy}</p>
                    <a
                      href={method.href}
                      target={isMail ? undefined : "_blank"}
                      rel={isMail ? undefined : "noopener noreferrer"}
                      aria-label={`${method.title}: ${method.label}`}
                    >
                      {method.label}
                    </a>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section-ms" aria-labelledby="contact-note-title">
        <div className="section-ms-inner primary-cta">
          <div>
            <p className="section-ms-kicker">What to send</p>
            <h2 id="contact-note-title">Start with the outcome.</h2>
            <p>
              A short note is enough: what should be easier, who needs it, and
              what is not working today.
            </p>
          </div>
          <a
            href="mailto:info@milesoft.africa"
            className="btn-ms btn-ms-primary btn-ms-md"
          >
            Send an email
          </a>
        </div>
      </section>
    </div>
  );
}

export default Contacts;
